import { Toggle } from 'aimo-ui';
import ApproveTermsText, {
  ApproveTermsType,
} from 'components/approveTerms/ApproveTermsText';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  CenterRow,
  ColumnWithMargins,
  RowSpaceBetween,
} from 'styles/ContainerStyles';

const ApproveTermsAgain: React.FC<{
  type: ApproveTermsType;
  approvedToggle: boolean;
  setApprovedToggle: (value: boolean) => void;
}> = ({ type, approvedToggle, setApprovedToggle }) => {
  const Row: any = type === 'Location' ? RowSpaceBetween : CenterRow;
  const { t } = useTranslation();

  return (
    <Row noFlex isVerticalCenter>
      <ApproveTermsText type={type} />
      <ColumnWithMargins ml={5}>
        <Toggle
          dark
          value={approvedToggle}
          onValueChange={setApprovedToggle}
          accessibilityLabel={t('term.approveTerms')}
          accessibilityRole="switch"
          accessibilityState={{ checked: approvedToggle }}
        />
      </ColumnWithMargins>
    </Row>
  );
};

export default ApproveTermsAgain;
